import type { ClientActionName, WizardSnapshot } from '../types/agent-chat.js'

/**
 * Wizard actions the agent chat may take given what the wizard currently shows.
 * Shared so the server (which tools the model is offered) and the browser (re-check
 * right before executing) apply the same rule. There is deliberately no action for
 * executing tests or saving history — that stays a human button press.
 */
export function availableClientTools(snapshot: WizardSnapshot | undefined): ClientActionName[] {
  if (!snapshot || snapshot.busy) return []
  const tools: ClientActionName[] = ['classify_requirements']
  if (snapshot.step === 'review_classification') tools.push('propose_test_generation')
  if (snapshot.path === 'default') {
    if (snapshot.step === 'review_test_cases' && snapshot.testCases.length > 0) {
      tools.push('regenerate_test_case', 'add_test_case')
    }
    // Moving from test-case review to the Robot script is a human decision: the model can
    // only show the confirm button. Once a script exists it may regenerate it.
    if (snapshot.step === 'review_test_cases' && snapshot.selectedTestCaseIds.length > 0) {
      tools.push('propose_robot_generation')
    }
    if (snapshot.step === 'review_robot_script' && snapshot.selectedTestCaseIds.length > 0) {
      tools.push('generate_robot_script')
    }
  }
  return tools
}
